/**
 * {@link reformatCommaList} formats a comma separated list with a single space in between items for consistency
 * @param value comma separated list to reformat
 * @returns well formed comma separated list
 */
export function reformatCommaList(value: string): string {
  if (!value) return '';

  return value
    .split(',')
    .map((v) => v.trim())
    .filter(Boolean)
    .join(', ');
}
